import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import FontAwesome Icons
import './resetpassword.css';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract the token from the URL (backend should provide it in the reset link)
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState({ text: '', isSuccess: false });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); 

  const isValidPassword = (password) => password.length >= 6;

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setMessage({ text: 'Please fill in all fields.', isSuccess: false });
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage({ text: 'Passwords do not match.', isSuccess: false });
      return;
    }

    if (!isValidPassword(newPassword)) {
      setMessage({ text: 'Password must be at least 6 characters.', isSuccess: false });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/reset-password', {
        token,
        newPassword,
      });

      setMessage({ text: response.data.message, isSuccess: true });

      // Redirect to sign-in after a delay
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setMessage({
        text: error.response?.data?.message || 'An unexpected error occurred.',
        isSuccess: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleResetPassword} className="reset-password-form">
        <div className="password-input-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <span
            className="show-password-btn"
            onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
            
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Display the icons */}
          </span>
        </div>
        <div className="password-input-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <span
            className="show-password-btn"
            onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
            
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />} 
          </span>
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
      {message.text && (
        <p className={message.isSuccess ? 'success-message' : 'error-message'}>
          {message.text}
        </p>
      )}
      <span onClick={() => navigate('/login')} className="back-to-login">
        Back to Sign In
      </span>
    </div>
  );
};

export default ResetPassword;
